import { render, staticRenderFns } from "./ffi.vue?vue&type=template&id=4effafe7&"
import script from "./ffi.vue?vue&type=script&lang=js&"
export * from "./ffi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports